import React from "react";
import ReactDOM from "react-dom";
import Container from "./Main/Container";

ReactDOM.render(
  <React.StrictMode>
    <Container />
  </React.StrictMode>,
  document.getElementById("root")
);
